import { VHCRecordCheckWheelTyreItemInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type SaveWheelItemInput = {
  logId: number;
  requestBody?: VHCRecordCheckWheelTyreItemInput;
};

export const useSaveWheelItemMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.postVhcRecordsWheelTyresCheck, SaveWheelItemInput>
) =>
  useMutationWithNotifications(
    ({ logId, requestBody }: SaveWheelItemInput) =>
      VhcRecordLogService.postVhcRecordsWheelTyresCheck(logId, requestBody),
    options
  );
